export default __webpack_public_path__ + "static/media/a015-4.bfe9e716.svg";